import { render, staticRenderFns } from "./NewMakerRegist.vue?vue&type=template&id=4dc223d4&"
import script from "./NewMakerRegist.vue?vue&type=script&lang=js&"
export * from "./NewMakerRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports